import axios from "axios";


const API = axios.create({

    baseURL: `${process.env.REACT_APP_BACKEND_URI}/api`

});




// KPI Cards

export const getReportSummary = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/summary",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Status Chart

export const getTicketStatusReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/status",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Priority Chart

export const getPriorityReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/priority",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Category Chart

export const getCategoryReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/category",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Monthly Trend

export const getMonthlyTrend = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/trend",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Resolution Time

export const getResolutionTimeReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/resolution-time",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// SLA

export const getSLAReport = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/sla",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Recent Tickets

export const getRecentTickets = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/recent",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Projects Overview (status/type breakdown)

export const getProjectsOverview = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/projects-overview",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Capacity Overview (distribution + top allocated + bench)

export const getCapacityOverview = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/capacity-overview",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};




// Board Overview (task status/type/priority + sprint velocity)

export const getBoardOverview = async(departmentId = null)=>{

    const response = await API.get(
        "/reports/board-overview",
        { params: { department_id: departmentId || undefined } }
    );

    return response.data;

};



export default API;